(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('EditFiController', EditFiController);

  /* ngInject */
  function EditFiController($stateParams, Flash, fiService, fiProductService, formErrorsService, productService, sessionService, usStates) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.deleteFi = deleteFi;
    vm.fi = {};
    vm.fiProductIds = [];
    vm.form = {};
    vm.getFi = getFi;
    vm.getFiProducts = getFiProducts;
    vm.getProducts = getProducts;
    vm.products = [];
    vm.saveFi = saveFi;
    vm.saveFiProducts = saveFiProducts;
    vm.sendWelcomeTrainingMessage = sendWelcomeTrainingMessage;
    vm.sendWelcomeMigrationMessage = sendWelcomeMigrationMessage;
    vm.states = usStates;

    vm.activate();

    function activate() {
      getFi();
      getFiProducts();
      getProducts();
    }

    function deleteFi() {
      fiService(sessionService.getAuthToken()).destroy({id: $stateParams.fiId});
    }

    function getFi() {
      vm.fi = fiService(sessionService.getAuthToken()).get({id: $stateParams.fiId});
    }

    function getFiProducts() {
      fiProductService(sessionService.getAuthToken()).query({fiId: $stateParams.fiId}, (response) => {
        vm.fiProductIds = response.map(product => product.id);
      });
    }

    function getProducts() {
      productService(sessionService.getAuthToken()).query(response => {vm.products = response;});
    }

    function saveFi() {
      vm.clearFormErrors(vm.form);
      fiService(sessionService.getAuthToken()).update({id: vm.fi.id}, vm.fi, updateFiSuccess, updateFiFailure);
    }

    function saveFiProducts() {
      fiProductService(sessionService.getAuthToken()).save({fiId: $stateParams.fiId}, {product_ids: vm.fiProductIds}, response => {
        vm.fiProductIds = response.map((product) => product.id);
        Flash.create('success', `${vm.fi.name} products were successfully updated.`);
      });
    }

    function sendWelcomeTrainingMessage() {
      fiService(sessionService.getAuthToken()).trainingWelcome({id: $stateParams.fiId}, _response => {
        Flash.create('success', 'Training welcome message successfully sent to all users.'); 
      });
    }

    function sendWelcomeMigrationMessage() {
      fiService(sessionService.getAuthToken()).migrationWelcome({id: $stateParams.fiId}, _response => {
        Flash.create('success', 'Migration welcome message successfully sent to all users.'); 
      });
    }

    function updateFiSuccess(_response) {
      Flash.create('success', `${vm.fi.name} was successfully updated.`);
    }

    function updateFiFailure(response) {
      Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
      vm.setFormErrors(vm.form, response);
    }
  }
})();
